import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRentalDashboard } from '../../Redux/Actions/actions';
import RentalDashboard from '../../Components/RentalDashboard/RentalDashboard';
import style from './RentalManagement.module.css';

const RentalManagement = () => {
  const dispatch = useDispatch();
  const { 
    rentalDashboard, 
    rentalsLoading, 
    rentalsError 
  } = useSelector(state => state);

  useEffect(() => {
    dispatch(fetchRentalDashboard());
  }, [dispatch]);

  if (rentalsLoading) {
    return (
      <div className={style.container}>
        <div className={style.loading}>Cargando dashboard de alquileres...</div>
      </div>
    );
  }

  if (rentalsError) {
    return (
      <div className={style.container}>
        <div className={style.error}>
          Error al cargar el dashboard: {rentalsError}
        </div>
      </div>
    );
  }

  return (
    <div className={style.container}>
      <h1 className={style.title}>Gestión de Alquileres</h1>
      
      <RentalDashboard data={rentalDashboard} />
    </div>
  );
};

export default RentalManagement;